// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".storyblok-titled-icon{display:flex;flex-direction:column;align-items:center;justify-content:center;margin:10px 0;padding:0 20px 0 0;height:90px}.storyblok-titled-icon__title{font-style:normal;font-weight:500;font-size:16px;line-height:22px;margin:0 0 5px;color:var(--q4s-ink)}.storyblok-titled-icon__icon{height:60px}.storyblok-titled-icon__icon img{height:100%}", ""]);
// Exports
module.exports = exports;
